import React from 'react'
import './Actions.css'

const ActionAdd = (props) => (
  <a className='action action--add' href='#add' onClick={props.onClick}>
    <i className='material-icons'>add</i>
  </a>
)

export { ActionAdd }
